import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  useTranslation,
  TablePopUpContainer,
  TableConnectionPopupsWr,
  PostMessageListenerMessages,
  PlatformMessagesWrapper,
  GameLaunchManager,
  applicationStore,
  popupStore,
  LoadingContainer,
  ContentLoader,
  loadingStore,
  betStore,
} from '@pascal/pascal-core';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';

import { FactoryRouter } from './factoryRouter';
import { gameLiveConnection } from '../services';
import { HelpPopup } from '../components/helpPopup';
import { SocketConnection } from './socketConnection';
import { globalTranslationKeys } from '../enums/translationKeys';
import { FairnessPopup } from '../components/fairnessPopup';
import { CheckHashPopup } from '../components/checkHashPop';
import { socketEventsHandlerDelays } from '../enums/replaySocetEventsDelays';
import { doBetStore } from '../store/doBetStore';
import { AppDefaultValuesEnum } from '../enums/appDefaultValues';
import logoPG from '../assets/images/logo-loading-png.png';

export const Factory = observer(({ components }) => {
  const t = useTranslation();
  const { gameIsOpen } = applicationStore;
  const { popupToggle, popupName } = popupStore;
  const { isAdditionalLoading } = loadingStore;
  const popupMap = useMemo(
    () => ({
      [PopUps.Fairness]: {
        component: FairnessPopup,
        title: t(globalTranslationKeys.Fairness),
      },
      [PopUps.CheckHash]: {
        component: CheckHashPopup,
        title: t(globalTranslationKeys.Check),
      },
      [PopUps.Reconnect]: {
        component: TableConnectionPopupsWr,
        title: t(globalTranslationKeys.Reconnect),
      },
      [PopUps.ConnectionError]: {
        component: TableConnectionPopupsWr,
        title: t(globalTranslationKeys.ConnectionError),
      },
      [PopUps.GameOpen]: {
        component: TableConnectionPopupsWr,
        title: t(globalTranslationKeys.GameOpen),
      },
      // [PopUps.MobileNavigation]: MobileNavigationPopupWr,
      [PopUps.Help]: {
        component: HelpPopup,
        title: t(globalTranslationKeys.Help),
      },
    }),
    [t]
  );

  useEffect(() => {
    applicationStore.setIsBogLine(true);
  }, []);

  const memoAdditionalMessagesParams = useMemo(() => {
    return [
      {
        name: PostMessageListenerMessages.UpdateBalance,
        callback: gameLiveConnection.getBalance(),
      },
      {
        name: PostMessageListenerMessages.ResumeGame,
        callback: () => {
          loadingStore.updateIsAdditionalLoading(true);
          setTimeout(() => loadingStore.updateIsAdditionalLoading(false), 3000);
        },
      },
    ];
  }, []);

  const repliedCallback = () => {
    const { repliedBetData } = betStore;
    doBetStore.setUserBets({
      ...doBetStore.userBets,
      [repliedBetData?.additionalParams?.index]: {
        ...doBetStore.userBets[repliedBetData?.additionalParams?.index],
        amount: repliedBetData?.amount,
      },
    });
  };
  return (
    <LoadingContainer
      appDefaultValuesEnum={AppDefaultValuesEnum}
      gameSpecificRepliedCallback={repliedCallback}
    >
      <PlatformMessagesWrapper additionalMessagesParams={memoAdditionalMessagesParams}>
        <GameLaunchManager
          socketEventsHandlerDelays={socketEventsHandlerDelays}
          GameContainer={<FactoryRouter components={components} />}
          SocketConnectionWr={
            <SocketConnection>
              <FactoryRouter components={components} />
            </SocketConnection>
          }
        />
      </PlatformMessagesWrapper>
      {isAdditionalLoading && <ContentLoader logoSrc={logoPG} isFull />}
      {((popupToggle && popupName) || gameIsOpen) && (
        <TablePopUpContainer popupMap={popupMap} gameIsOpen={gameIsOpen} />
      )}
    </LoadingContainer>
  );
});
